import React from 'react';
import { TextInput } from '@carbon/react';

const OneGUISettings: React.FC = () => (
  <>
    <div className="settings-page__form-grid">
      <TextInput id="onegui-refresh" labelText="Refresh interval (seconds)" placeholder="30" />
      <TextInput id="onegui-option1" labelText="Option 1" placeholder="X" />
      <TextInput id="onegui-option2" labelText="Option 2" placeholder="Y" />
      <TextInput id="onegui-option3" labelText="Option 3" placeholder="Z" />
    </div>
  </>
);

export default OneGUISettings;
